import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: {}, error: "", message: "" }


export const getPUblisherTokenAction = createAsyncThunk(
    'get-publisher-Token',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/get-publisher-token?publisher_id=${data?.publisherId}`) 
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getPublisherTokenSlice = createSlice({
    name: 'get-publisher-Token',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getPUblisherTokenAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getPUblisherTokenAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getPUblisherTokenAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getPublisherTokenReducer = getPublisherTokenSlice.reducer